// extracted by mini-css-extract-plugin
export default {"tags":"sJkdmKyV4CO7EwmHy4sw","tag":"xRsK_SP0qe17lOWjgNy6"};